var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6885 18.5848V20.4788L13.0373 21.4501L11.4347 20.4788V18.5848L13.0373 19.5561L14.6885 18.5848ZM5.84998 12.0288L7.45256 13V16.2538L10.2207 17.9049V19.7989L5.84998 17.2251V12.0288ZM20.2247 12.0288V17.2251L15.8054 19.7989V17.9049L18.5735 16.2538V13L20.2247 12.0288ZM15.8054 9.45493L17.4566 10.4262V12.3202L14.6885 13.9713V17.2736L13.0859 18.2449L11.4833 17.2736V13.9713L8.61808 12.3202V10.4262L10.2692 9.45493L13.0373 11.1061L15.8054 9.45493ZM8.61808 13.6799L10.2207 14.6512V16.5452L8.61808 15.5739V13.6799ZM17.4566 13.6799V15.5739L15.854 16.5452V14.6512L17.4566 13.6799ZM7.45256 7.80378L9.10371 8.77505L7.45256 9.74631V11.6403L5.84998 10.669V8.77505L7.45256 7.80378ZM18.6221 7.80378L20.2732 8.77505V10.669L18.6221 11.6403V9.74631L17.0195 8.77505L18.6221 7.80378ZM13.0373 7.80378L14.6885 8.77505L13.0373 9.74631L11.4347 8.77505L13.0373 7.80378ZM13.0373 4.55005L17.4566 7.1239L15.854 8.09516L13.0859 6.44401L10.2692 8.09516L8.66664 7.1239L13.0373 4.55005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.a05be28622a6d7ff4ce773afa544c9cb.svg";
export { ForwardRef as ReactComponent };